import React from 'react';
import WifiIcon from '@mui/icons-material/Wifi';
import GavelIcon from '@mui/icons-material/Gavel';
import './Guide.css';

const Guide = () => {
  return (
    <div className="page-container">
      <div className="page-header">
        <h1>Guía del Departamento</h1>
      </div>

      <div className="page-content">
        <section className="page-section section-gradient-left">
          <div className="section-header">
            <WifiIcon sx={{ fontSize: 32, color: '#606C38' }} />
            <h2>WiFi</h2>
          </div>
          <div className="wifi-info">
            <div className="info-item">
              <span className="label">Red:</span>
              <span className="value">Internet_6F:64</span>
            </div>
            <div className="info-item">
              <span className="label">Contraseña:</span>
              <span className="value">22450K7B00648</span>
            </div>
          </div>
        </section>

        <section className="page-section section-gradient-right">
          <div className="section-header">
            <GavelIcon sx={{ fontSize: 32, color: '#606C38' }} />
            <h2>Normas del Departamento</h2>
          </div>
          <div className="rules-content">
            <p className="rules-intro">
              Para mantener un ambiente agradable y seguro para todos, por favor sigue estas normas:
            </p>
            <ul className="rules-list">
              <li>Mantén el departamento limpio y ordenado</li>
              <li>No fumar dentro del departamento</li>
              <li>Apagar luces y electrodomésticos cuando no se usen</li>
              <li>Respetar las áreas comunes y a los vecinos</li>
            </ul>
          </div>
        </section>
      </div>
    </div>
  );
};

export default Guide; 